import { Component, OnInit } from "@angular/core";
import { Subject } from "rxjs/Subject";
import { debounceTime } from "rxjs/operators";
import { CodigoProducto } from "../../../../model/class/CodigoProducto";
import * as _ from "lodash";
import { CodigosProductoService } from "../../../services/codigos-prodicto/codigos-producto.service";
import { PreferencesService } from '../../../services/preferences/preferences.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CrearCodigoComponent } from "../crear-codigo/crear-codigo.component";

@Component({
  selector: "app-listado-codigos",
  templateUrl: "./listado-codigos.component.html",
  styleUrls: ["./listado-codigos.component.css"],
  providers: [PreferencesService],
})
export class ListadoCodigosComponent implements OnInit {
  loader = {
    tabla: false,
  };
  textoBuscar: string;
  textoBuscarChanged: Subject<string> = new Subject<string>();

  page = 1;
  perPage = 200;
  totalData = 0;
  codigosTodos: CodigoProducto[] = [];
  prefDiscountLimits: any = null;
  orderSelected: any;
  headerTable: any[] = [
    {
      text: "Código",
      value: "codigo",
    },
    {
      text: "Descripción",
      value: "descripcion",
    },
    {
      text: "Nombre web",
      value: "produtoNombre",
    },
    {
      text: 'Dcto%',
      value: 'descuentoPorcentaje',
    },
    {
      text: "Valor",
      value: "valor",
    },
    {
      text: "Valor USD",
      value: "valorUsd",
    },
  ];

  selStatus = "TODOS";

  constructor(
    private codigosProductoService: CodigosProductoService,
    private modalService: NgbModal,
    private preferencesService: PreferencesService
  ) {
    this.textoBuscarChanged
      .pipe(debounceTime(500)) // wait 1 sec after the last event before emitting last event
      .subscribe((model) => {
        this.textoBuscar = model.toString();
        this.loadCodes();
      });
  }

  ngOnInit() {
    this.loadPreferences();
  }

  loadPreferences() {
    this.preferencesService.getByName('discount_min_max').subscribe(
      (response: any) => {
        let loaded = null;
        try {
          // API may return wrapped object { data: { value: '...'} } or the value directly
          let raw: any = null;
          if (response && response.data && response.data.value !== undefined) {
            raw = response.data.value;
          } else if (response && response.value !== undefined) {
            raw = response.value;
          } else {
            raw = response;
          }
          loaded = typeof raw === 'string' ? JSON.parse(raw) : raw;
        } catch (e) {
          loaded = null;
        }
        if (loaded && typeof loaded === 'object') {
          // normalize keys by removing whitespace/newlines in case backend stored malformed keys
          const normalized: any = {};
          Object.keys(loaded).forEach(k => {
            const nk = k.replace(/\s+/g, '');
            normalized[nk] = loaded[k];
          });
          this.prefDiscountLimits = normalized;
        } else {
          this.prefDiscountLimits = null;
        }
        this.loadCodes();
      },
      () => {
        this.prefDiscountLimits = null;
        this.loadCodes();
      }
    );
  }

  onTextoBuscarChange(texto: string) {
    this.textoBuscarChanged.next(texto);
  }

  loadCodes() {
    this.loader.tabla = true;
    this.codigosTodos = [];
    const parametros: any = {};

    let texto: string;
    if (this.textoBuscar) {
      texto = this.textoBuscar.trim();
    }
    if (texto) {
      const objetoBucar: any = [
        { code: texto },
        { description: texto },
        { value: texto },
      ];
      parametros.search = JSON.stringify(objetoBucar);
    }
    const paginador = {
      since: (this.page - 1) * this.perPage,
      quantity: this.perPage,
    };
    parametros.paginator = JSON.stringify(paginador);
    parametros.filter = this.selStatus;

    this.codigosProductoService.gatAll(parametros).subscribe(
      (response) => {
        this.loader.tabla = false;
        this.totalData = response.total;
        for (const icode of response.data) {
          const cp = new CodigoProducto(icode);
          // expose percentage property used in table and ordering
          (cp as any).descuentoPorcentaje = cp.descuento;
          // classify as oferta/descuento using preferences when available
          if (this.prefDiscountLimits) {
            const d = cp.descuento;
            const p = this.prefDiscountLimits;
            if (d >= p.min_oferta && d <= p.max_oferta) {
              (cp as any).descuentoTipo = 'OFERTA';
              (cp as any).descuentoLabel = p.label_oferta || 'Oferta';
            } else if (d >= p.min_descuento && d <= p.max_descuento) {
              (cp as any).descuentoTipo = 'DESCUENTO';
              (cp as any).descuentoLabel = p.label_descuento || 'Descuento';
            } else {
              (cp as any).descuentoTipo = 'NONE';
              (cp as any).descuentoLabel = '';
            }
          }
          this.codigosTodos.push(cp);
        }
        this.orderData();
      },
      (error) => {
        this.loader.tabla = false;
      }
    );
  }

  limpiarTexto() {
    this.textoBuscar = "";
    this.loadCodes();
  }

  changeValueOrder(index: number) {
    if (this.headerTable[index].value) {
      for (let i = 0; i < this.headerTable.length; i++) {
        if (i === index) {
          if (this.headerTable[i].order === "desc") {
            this.headerTable[i].order = "asc";
          } else if (this.headerTable[i].order === "asc") {
            this.headerTable[i].order = "desc";
          } else if (!this.headerTable[i].order) {
            this.headerTable[i].order = "asc";
          }
        } else {
          this.headerTable[i].order = undefined;
        }
      }
      this.orderSelected = this.headerTable[index];
      this.orderData();
    }
  }

  orderData() {
    if (this.orderSelected) {
      this.codigosTodos = _.orderBy(
        this.codigosTodos,
        this.orderSelected.value,
        this.orderSelected.order
      );
    }
  }

  pageChange(event) {
    this.page = event;
    this.loadCodes();
  }

  crearEditarCodigo(codigo?: CodigoProducto) {
    let clon: any = {};

    if (codigo) {
      clon = _.clone(codigo);
    }

    const viewModal = this.modalService.open(CrearCodigoComponent, {
      size: "lg",
      windowClass: "modal-admin",
    });
    viewModal.componentInstance.newCodigo = clon;

    viewModal.result.then(
      (newCodigo: CodigoProducto) => {
        const newObj = new CodigoProducto(newCodigo);
        if (clon.id) {
          // Editando
          const indice = _.findIndex(this.codigosTodos, { id: newObj.id });
          if (indice >= 0) {
            this.codigosTodos[indice] = newObj;
          }
        } else {
          // Nuevo
          if (this.codigosTodos.length < this.perPage) {
            this.codigosTodos.push(newObj);
          }
        }
      },
      (reason) => {}
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/listado-codigos/listado-codigos.component.ts